import { render } from "./topPage.vue?vue&type=template&id=4c0d6179"
import script from "./topPage.vue?vue&type=script&lang=js"
export * from "./topPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__